import React, {
  useState
} from "react";

import {
  X,
  RadioTower,
  Hash,
  Smartphone
} from "lucide-react";

import "../Styles/NewSimModal.css";

const NewSimModal = ({
  closeModal,
  addSim,
}) => {

const [form, setForm] =
useState({

  gsm_number: "",

  serial_number: "",

  network: "DIGICEL",

});


  const handleChange = (e) => {

    setForm({

      ...form,

      [e.target.name]:
        e.target.value,

    });

  };

  const handleSubmit = (e) => {

    e.preventDefault();
if (

!form.gsm_number.trim() ||

!form.serial_number.trim()

) {

      alert(
        "Please complete all fields."
      );

      return;

    }

    addSim(form);

    closeModal();

  };

  return (

    <div
      className="sim-modal-overlay"
      onClick={closeModal}
    >

      <div
        className="sim-modal"
        onClick={(e) =>
          e.stopPropagation()
        }
      >

        {/* HEADER */}

        <div className="sim-modal-header">

          <div>

            <h2>
              New SIM Record
            </h2>

            <p>
              Add a SIM card to
              inventory.
            </p>

          </div>

          <button
            className="close-btn"
            onClick={closeModal}
          >

            <X size={20} />

          </button>

        </div>

        <form
          onSubmit={handleSubmit}
        >

          {/* GSM */}

          <div className="input-group">

            <label>

              <Smartphone
                size={16}
              />

              GSM Number

            </label>

            <input
              type="text"
              name="gsm_number"
              placeholder="e.g. 6281234"
              value={form.gsm_number}
              onChange={
                handleChange
              }
            />

          </div>

          {/* SERIAL */}

          <div className="input-group">

            <label>

              <Hash size={16} />

              Serial Number

            </label>

            <input
              type="text"
              name="serial_number"
              placeholder="SIM Serial Number"
              value={form.serial_number}
              onChange={
                handleChange
              }
            />

          </div>

          {/* NETWORK */}

          <div className="input-group">

            <label>

              <RadioTower
                size={16}
              />

              Network

            </label>

            <select
              name="network"
              value={
                form.network
              }
              onChange={
                handleChange
              }
            >

<option value="DIGICEL">
Digicel
</option>

<option value="GTT">
GTT
</option>

<option value="ENET">
ENet
</option>

            </select>

          </div>

          {/* FOOTER */}

          <div className="modal-actions">

            <button
              type="button"
              className="cancel-btn"
              onClick={
                closeModal
              }
            >
              Cancel
            </button>

            <button
              type="submit"
              className="save-btn"
            >
              Save SIM
            </button>

          </div>

        </form>

      </div>

    </div>

  );

};

export default NewSimModal;